//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"LightsShadedViewsLightingCollection",1,0],[0,"LightsShadedViewsSceneDimmerValue",1,0]],[[["index"],"GetLightBuilderFromList",{R_:{light:"Display.LightBuilder"}},1,0],[["index","light"],"SetLightBuilderInList",{},2,0],[["lightName","lightIntensity"],"SetLightBuilderInList1",{},2,0],[["lightName"],"RemoveLightBuilderInList",{},1,0],[[],"GetNumLightBuilders",{R_:{total_lights:''}},0,0],[["lightSet"],"EnableLightsOfLightSet",{},1,0]],[]];
SPLM.Display.Lighting = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.Lighting";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.Lighting.LightingCollectionType = Object.freeze({
    "Lighting1" : "Lighting1", "Lighting2" : "Lighting2", "Lighting3" : "Lighting3", "Lighting4" : "Lighting4", "Lighting5" : "Lighting5", "UserDefined" : "UserDefined"});

SPLM.Display.Lighting.LightingSet = Object.freeze({
    "Scene" : "Scene", "Analysis" : "Analysis"});

export default SPLM;